import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { User } from '../models/user.model';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit, OnDestroy {

  selectedTab: string;
  sideBarOpened: boolean = true;
  alertCode: string = '';

  user: User;
  userSubscription: Subscription;

  isDarkThemeSubscription: Subscription;
  isDarkTheme: boolean;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private configService: ConfigService) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if (this.route.snapshot.params['tab']) {
          this.selectedTab = params['tab'];
        } else {
          this.selectedTab = 'portfolio-models';
        }
      }
    );

    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );

    this.isDarkThemeSubscription = this.configService.isDarkThemeSubject.subscribe(
      (isDarkTheme: boolean) => {
        this.isDarkTheme = isDarkTheme;
      }
    );
    this.configService.emitIsDarkTheme();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.isDarkThemeSubscription.unsubscribe();
  }

  async onSignOut() {
    const data:any = await this.authService.signOutUser();
    this.alertCode = 'auth/sign-out-ok';
    this.router.navigate(['/']);
  }

  onThemeChange() {
    this.configService.onSwitchTheme();
  }
}
